import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { ButtonModule } from 'primeng/button';
import { MessageModule } from 'primeng/message';
import { EditorModule } from 'primeng/editor';
import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { LoginOriginalComponent } from './login-original.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './index';
import { NgModule } from '@angular/core';
import { ImageUploaderComponent } from './../shared/ecpl-article-viewer/image-uploader.component';
import { SearchListPipe } from '../shared/_helpers/pipes';
import { AppSharedModule } from '../kuba/shared';
@NgModule({
  imports: [
    CommonModule,
    InputTextModule,
    PasswordModule,
    ButtonModule,
    MessageModule,
    RouterModule,
    FormsModule,
    EditorModule,
    SelectModule,
    CheckboxModule,
    DialogModule,
    AppSharedModule
  ],
  exports: [LoginComponent, LoginOriginalComponent],
  declarations: [
    SearchListPipe,
    LoginComponent,
    LoginOriginalComponent,
    ImageUploaderComponent
  ],
  providers: []
})
export class LoginModule {}
